import styled from 'styled-components';
import colors from 'styles/colors';
import sizes from 'styles/sizes';
import { BrandCode } from 'types';

export const Rating = styled.div`
	display: flex;
	align-items: center;
	cursor: pointer;
`;

export const Container = styled.div`
	display: flex;
	align-items: center;
	justify-content: flex-start;
	gap: 5px;
	@media (max-width: ${sizes.media.smallMaxWidth}px) {
		flex-direction: column;
		align-items: flex-start;
	}

	/* Rating Stars and Text Container*/
	[data-bv-show='inline_rating'] .bv_main_container {
		width: 100%;

		@media (max-width: ${sizes.media.mediumMinWidth}px) {
			flex-direction: row;
		}

		@media (max-width: ${sizes.media.xSmallMaxWidth}px) {
			margin-top: 0px !important;	
		}
	}

	/* Rating Stars Container */
	[data-bv-show='inline_rating'] .bv_main_container .bv_stars_component_container {
		width: 83px !important;
	}

	/* Rating Text */
	[data-bv-show='inline_rating'] .bv_main_container .bv_text {
		font-size: 12px !important;
		${({ theme }) =>
		({
			[BrandCode.Celebrity]: `
                    color: ${colors.functional.blueRaiting} !important;
                `,
			[BrandCode.RoyalCaribbean]: `
                    color: ${colors.functional.blueButton} !important;
                `,
		})[theme.brandCode]}
	}

	[data-bv-show='inline_rating'] .bv_main_container .bv_numReviews_component_container {
		display: none !important;
	}
`;
